import styled from '@emotion/styled';

const Logo = styled.img`
  width: ${props => props.width || 30}px;
  cursor: pointer;
`;

export default Logo;
